// @core/api/endpoints/workflow/create_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateScheduleRequest,
  PipelineScheduleResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Create pipeline schedule
 * Creates a schedule to automatically execute the pipeline at specified intervals (cron, interval, or one-time).
 */
export async function CreateSchedule(
  pipeline_id: string,
  data: CreateScheduleRequest,
  options?: RequestOptions
): Promise<PipelineScheduleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/schedules`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.post<PipelineScheduleResponse>(requestPath, data, requestOptions);
}
